import React from 'react';
import FieldRow from './FieldRow';

/**
 * Modern (Tailwind) counterpart of components/PropertySwitch.
 *
 * Same name, same props, same outward handleChange(propertyName, "1"|"0") contract.
 * Everything above render() is copied verbatim, componentDidUpdate included — that is
 * what resyncs the toggle when the parent changes the value, e.g. an enable switch
 * being cleared because another feature took ownership.
 *
 * Only render() differs: the legacy `Row` + two `Col sm="6"` give way to a FieldRow, so
 * the toggle shares the card's label/control/unit grid tracks and lines up with the
 * pickers and dropdowns beside it instead of splitting the row 50/50 on its own.
 *
 * The `.switch` / `.slider round` markup and its CSS are reused unchanged — this is the
 * same toggle users already know, only positioned by the card's grid.
 */
export default class PropertySwitch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isChecked: this.props.property.value === "1"
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {

        const value = e.target.checked;
        this.setState({
            isChecked: value
        });

        this.props.handleChange(this.props.property.info.name, value ? "1" : "0");
    }

    componentDidUpdate(prevProps) {
        if (this.props.property.value !== prevProps.property.value) {
            this.setState({ isChecked: this.props.property.value === "1" });
        }
    }

    render() {

        return (
            <FieldRow label={this.props.title} disabled={this.props.disabled} className={this.props.className}>
                <label className="switch">
                    <input
                        disabled={this.props.disabled}
                        name={this.props.property.info.name}
                        type="checkbox"
                        checked={this.state.isChecked}
                        onChange={this.handleChange} />
                    <span className="slider round"></span>
                </label>
            </FieldRow>
        );
    };
}
